import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoadingOverlay from "./LoadingOverlay";
import ChatWidget from "./ChatWidget";
import AiChatModal from "./AiChatModal";
import { Bot, FileSearch } from "lucide-react";
import ReleaseBalloon from "./ReleaseBalloon";
import ParasutBadge from "./ParasutBadge";
import ChangePassword from "./ChangePassword";
import { BrandMark, BrandName, logoSrc } from "./Brand";
import CollapseBar, { BarCtx } from "./CollapseBar";
import { PhoneCall, Boxes, Scale, MessageCircle, Warehouse, Inbox, Link2, Wallet, TrendingUp, ClipboardCheck, Receipt, Network,
  LayoutDashboard, Users, BarChart3, Map, PackagePlus, Truck,
  FileText, FileSignature, Factory, Settings, HelpCircle, LogOut,
  ChevronLeft, ChevronRight, ChevronDown, Box, Sun, Moon, LayoutGrid, ZoomIn, ZoomOut, Minimize2, Zap, Copy, Building2, Calculator, ListChecks, PackageCheck, Navigation, Trash2, Briefcase, GripVertical, Eye, EyeOff, PencilLine, Check, Plus, X, FolderPlus, Rows2, Rows3, Menu, ArrowUpToLine,
} from "lucide-react";
import { getRowH } from "./RowSizeSettings";
import api from "../lib/api";
import { toast } from "sonner";

const _cy = new Date().getFullYear();
const YEARS = [];
for (let y = _cy + 1; y >= 2023; y--) YEARS.push(String(y));
YEARS.push("all");

export const NAV = [
  { to: "/", label: "GÖSTERGE PANELİ", icon: LayoutDashboard, end: true, sec: "dashboard" },
  { to: "/firmalar", label: "FİRMA YÖNETİMİ", icon: Building2, super: true },
  { to: "/silme-onaylari", label: "SİLME ONAYLARI", icon: Trash2, super: true },
  { to: "/ambarlar", label: "AMBAR & ŞUBE AĞI", icon: Warehouse },
  { to: "/musteriler", label: "MÜŞTERİLER", icon: Users, sec: "musteriler" },
  { to: "/mukerrer", label: "MÜKERRER FİRMALAR", icon: Copy, sec: "mukerrer" },
  { to: "/hizli-ekle", label: "HIZLI FİRMA EKLE", icon: Zap, sec: "hizli-ekle" },
  { to: "/analiz", label: "ANALİZ FORMU", icon: FileSearch, sec: "hesaplama" },
  { to: "/raporlar", label: "RAPORLAR", icon: BarChart3, sec: "raporlar" },
  { to: "/harita", label: "MÜŞTERİ HARİTASI", icon: Map, sec: "harita" },
  { to: "/kargo-girisi", label: "KARGO GİRİŞİ", icon: PackagePlus, sec: "kargo-girisi" },
  { to: "/kargolar", label: "GÖNDERİLEN KARGOLAR", icon: Truck, sec: "kargolar" },
  { to: "/gelen-kargolar", label: "GELEN GİDEN KARGOLAR", icon: Inbox, sec: "kargolar" },
  { to: "/eslesmeler", label: "BEKLEYEN EŞLEŞMELER", icon: Link2, sec: "kargolar" },
  { to: "/kasa", label: "KASA", icon: Wallet, sec: "muhasebe" },
  { to: "/suspans", label: "SÜSPANS (ALACAK TAKİP)", icon: PhoneCall, sec: "muhasebe" },
  { to: "/surucu-gun-sonu", label: "SÜRÜCÜ GÜN SONU", icon: ClipboardCheck, sec: "muhasebe" },
  { to: "/faturalar", label: "FATURA BEKLEYENLER", icon: Receipt, sec: "muhasebe" },
  { to: "/cekler", label: "ÇEK VADE TAKİBİ", icon: FileText, sec: "muhasebe" },
  { to: "/cari-kargo", label: "CARİ KARGO RAPORU", icon: BarChart3, sec: "muhasebe" },
  { to: "/ortak-hesap", label: "KARŞILIKLI HESAP", icon: Link2, sec: "muhasebe" },
  { to: "/sube-merkezi", label: "ŞUBE MERKEZİ", icon: Building2 },
  { to: "/grup-panosu", label: "GRUP PANOSU", icon: Network, sec: "muhasebe" },
  { to: "/kargo-alimi", label: "KARGO ALIMI", icon: PackageCheck, sec: "kargo-alimi" },
  { to: "/alim-ozet", label: "ALIM ÖZET", icon: PackageCheck, sec: "kargo-alimi" },
  { to: "/araclar", label: "ARAÇ KAYDET", icon: Truck, sec: "kargo-alimi" },
  { to: "/tir-rota", label: "TIR ROTA", icon: Navigation, sec: "tir-rota" },
  { to: "/tir-plan", label: "TIR YÜKLEME (3D)", icon: Boxes, sec: "tir-rota" },
  { to: "/navlun-hakedis", label: "NAVLUN & HAK EDİŞ", icon: Scale, sec: "tir-rota" },
  { to: "/gunluk-kar", label: "GÜNLÜK KÂR ÖZETİ", icon: TrendingUp, sec: "tir-rota" },
  { to: "/sofor?ro=1", label: "ŞOFÖR EKRANI", icon: Truck, sec: "sofor" },
  { to: "/hesaplama", label: "HESAPLAMA", icon: Calculator, sec: "hesaplama" },
  { to: "/calisma-odasi", label: "ÇALIŞMA ODASI", icon: Briefcase, sec: "calisma-odasi" },
  { to: "/teklifler", label: "TEKLİFLER", icon: FileText, sec: "teklifler" },
  { to: "/sozlesmeler", label: "SÖZLEŞMELER", icon: FileSignature, sec: "sozlesmeler" },
  { to: "/sozlesme-ayristir", label: "SÖZLEŞME AYRIŞTIR", icon: FileSignature },
  { to: "/tedarikci", label: "TEDARİKÇİ", icon: Factory, sec: "tedarikci" },
  { to: "/muhasebe", label: "MUHASEBE", icon: Calculator, sec: "muhasebe" },
  { to: "/is-listesi", label: "İŞ LİSTESİ", icon: ListChecks, sec: "is-listesi" },
  { to: "/ayarlar", label: "AYARLAR", icon: Settings, admin: true, sec: "ayarlar" },
  { to: "/yardim", label: "YARDIM", icon: HelpCircle },
];

function TopActions({ items }) {
  if (!items.length) return <span className="mw-hint text-[10px] text-slate-500">SOL MENÜDEN SAYFALARI BURAYA SÜRÜKLEYİN</span>;
  return (
    <div data-testid="top-actions" className="contents">
      {items.map((n) => { const Icon = n.icon; return (
        <NavLink key={n.to} to={n.to} end={n.end} draggable onDragStart={(e) => e.dataTransfer.setData("text/plain", `mwtop:${n.to}`)} title={`${n.label} · SOL MENÜYE GERİ SÜRÜKLEYEBİLİRSİNİZ`}
          data-testid={`top-action-${n.to === "/" ? "dashboard" : n.to.slice(1)}`}
          className={({ isActive }) => `flex h-7 min-w-0 max-w-[170px] shrink items-center gap-1 rounded-md border px-2 text-[11px] font-semibold ${isActive ? "border-blue-500/40 bg-blue-500/15 text-blue-300" : "border-slate-700/70 text-slate-300 hover:bg-slate-800 hover:text-white"}`}>
          <Icon className="h-3.5 w-3.5 shrink-0" /><span className="truncate">{n.label}</span>
        </NavLink>
      ); })}
    </div>
  );
}

export default function Layout({ children }) {
  const { user, isAdmin, isSuperAdmin, logout, tenantInfo, perms, selectedTenant, year, setTenant, setYear } = useAuth();
  const [collapsed, setCollapsedRaw] = useState(false);
  const [aiChat, setAiChat] = useState(false);
  const [mobile, setMobile] = useState(() => window.matchMedia("(max-width: 767px)").matches);
  const [drawer, setDrawer] = useState(false);
  useEffect(() => { const m = window.matchMedia("(max-width: 767px)"); const f = () => setMobile(m.matches); m.addEventListener("change", f); return () => m.removeEventListener("change", f); }, []);
  const setCollapsed = (f) => (mobile ? setDrawer((d) => !d) : setCollapsedRaw(f));
  const navClick = () => mobile && setDrawer(false);
  useEffect(() => {
    const n = tenantInfo?.name;
    document.title = n ? (tenantInfo.hide_mw ? n : `${n} · MWCRMPRO`) : "MWCRMPRO";
    let link = document.querySelector("link[rel='icon']");
    if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
    if (!link.dataset.orig) link.dataset.orig = link.href || "/favicon.ico";
    link.href = tenantInfo?.logo_url ? logoSrc(tenantInfo.logo_url) : link.dataset.orig;
  }, [tenantInfo]);
  const [barEls, setBarEls] = useState({});
  const [barOpen, setBarOpen] = useState(null);
  const barRefs = React.useMemo(() => Object.fromEntries(["title", "toggles", "panel"].map((k) => [k, (el) => setBarEls((p) => (p[k] === el || !el ? p : { ...p, [k]: el }))])), []);
  const [actionBars, setActionBars] = useState([]);
  const [more, setMore] = useState([]);
  const [moreOpen, setMoreOpen] = useState(false);
  useEffect(() => {
    const els = [barEls.toggles, barEls.panel].filter(Boolean);
    const over = (e) => { if ([...(e.dataTransfer?.types || [])].includes("text/plain")) { e.preventDefault(); e.currentTarget.classList.add("ring-2", "ring-emerald-500"); } };
    const leave = (e) => e.currentTarget.classList.remove("ring-2", "ring-emerald-500");
    const drop = (e) => { e.currentTarget.classList.remove("ring-2", "ring-emerald-500"); dropRef.current && dropRef.current(e); };
    els.forEach((el) => { el.addEventListener("dragover", over); el.addEventListener("dragleave", leave); el.addEventListener("drop", drop); });
    return () => els.forEach((el) => { el.removeEventListener("dragover", over); el.removeEventListener("dragleave", leave); el.removeEventListener("drop", drop); });
  }, [barEls]);
  useEffect(() => {
    const el = barEls.panel;
    if (!el) return;
    const PAL = ["#3b82f6", "#10b981", "#f59e0b", "#8b5cf6", "#ec4899", "#06b6d4", "#ef4444", "#84cc16", "#f97316", "#14b8a6"];
    const paint = () => {
      if (!el.classList.contains("mw-actions")) { el.querySelectorAll("[data-mwc]").forEach((b) => { b.removeAttribute("data-mwc"); b.style.removeProperty("--mwc"); }); return; }
      const items = [...el.querySelectorAll("button, a, label")].filter((b) => b.tagName !== "LABEL" || b.querySelector("input[type=file]") || b.className.includes("cursor-pointer")).filter((b) => !b.closest("[role=dialog]") && !b.closest(".mw-hint") && !b.parentElement.closest("[data-mwc]"));
      const okey = `mwcrm_act_order:${window.location.pathname}`;
      let ord = []; try { ord = JSON.parse(localStorage.getItem(okey) || "[]"); } catch (e) {}
      const keyOf = (b) => (b.textContent || "").trim();
      items.forEach((b, i) => {
        const c = PAL[i % PAL.length];
        if (b.style.getPropertyValue("--mwc") !== c) { b.setAttribute("data-mwc", "1"); b.style.setProperty("--mwc", c); }
        const oi = ord.indexOf(keyOf(b)); const o = String(oi === -1 ? 100 + i : oi);
        if (b.style.order !== o) b.style.order = o;
        if (!b.dataset.mwdnd) {
          b.dataset.mwdnd = "1"; b.draggable = true;
          b.addEventListener("dragstart", (e) => { window.__mwDragKey = keyOf(b); if (!e.dataTransfer.getData("text/plain")) e.dataTransfer.setData("text/plain", `mwkey:${keyOf(b)}`); });
          b.addEventListener("dragend", () => { window.__mwDragKey = null; });
          b.addEventListener("dragover", (e) => { if (window.__mwDragKey) e.preventDefault(); });
          b.addEventListener("drop", (e) => {
            const from = window.__mwDragKey; window.__mwDragKey = null;
            if (!from) return;
            e.preventDefault(); e.stopPropagation();
            const cur = [...el.querySelectorAll("[data-mwc]")].sort((x, y) => Number(x.style.order) - Number(y.style.order)).map(keyOf).filter((k) => k !== from);
            cur.splice(cur.indexOf(keyOf(b)), 0, from);
            localStorage.setItem(okey, JSON.stringify(cur)); paint();
          });
        }
      });
    };
    let raf = 0;
    const measure = () => {
      const btns = [...el.querySelectorAll("[data-mwc]")];
      btns.forEach((b) => b.removeAttribute("data-mwover"));
      const fits = (lim) => btns.filter((b) => b.offsetWidth && b.offsetLeft + b.offsetWidth > lim);
      let over = el.classList.contains("mw-actions") ? fits(el.clientWidth - 8) : [];
      if (over.length) over = fits(el.clientWidth - 180);
      over.forEach((b) => b.setAttribute("data-mwover", "1"));
      const list = over.sort((x, y) => Number(x.style.order) - Number(y.style.order)).map((b) => ({ key: (b.textContent || "").trim(), el: b }));
      setMore((p) => (p.map((x) => x.key).join("|") === list.map((x) => x.key).join("|") && p.every((x, i) => x.el === list[i].el) ? p : list));
    };
    const run = () => { paint(); cancelAnimationFrame(raf); raf = requestAnimationFrame(measure); };
    run();
    const mo = new MutationObserver(run);
    mo.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
    const ro = new ResizeObserver(() => { cancelAnimationFrame(raf); raf = requestAnimationFrame(measure); });
    ro.observe(el);
    return () => { mo.disconnect(); ro.disconnect(); cancelAnimationFrame(raf); };
  }, [barEls]);
  const actionBarsRef = useRef([]);
  actionBarsRef.current = actionBars;
  const regBar = React.useCallback((id, on) => setActionBars((l) => (on ? (l.includes(id) ? l : [...l, id]) : l.filter((x) => x !== id))), []);
  const barCtx = React.useMemo(() => ({ els: barEls, openId: barOpen, setOpenId: setBarOpen, reg: regBar }), [barEls, barOpen, regBar]);
  const [version, setVersion] = useState("");
  const [firms, setFirms] = useState([]);
  const [light, setLight] = useState(() => typeof document !== "undefined" && document.documentElement.classList.contains("light"));
  const [zoom, setZoom] = useState(() => parseFloat(localStorage.getItem("mwcrm_zoom")) || 1);
  const [rowH, setRowH] = useState(getRowH);
  useEffect(() => { const f = () => setRowH(getRowH()); window.addEventListener("mw-rowh", f); return () => window.removeEventListener("mw-rowh", f); }, []);
  const navigate = useNavigate();

  const [orgBranches, setOrgBranches] = useState([]);
  const menuAdmin = isSuperAdmin || (isAdmin && orgBranches.some((b) => b.is_root && b.id === user?.tenant_id));
  const [editMenu, setEditMenu] = useState(false);
  const [menuOrder, setMenuOrder] = useState(() => { try { return JSON.parse(localStorage.getItem("mwcrm_menu_order") || "[]"); } catch { return []; } });
  const [menuHidden, setMenuHidden] = useState(() => { try { return JSON.parse(localStorage.getItem("mwcrm_menu_hidden") || "[]"); } catch { return []; } });
  const dragRef = useRef(null);
  const menuDirty = useRef(false);
  const persistMenu = (order, hidden) => { menuDirty.current = true; localStorage.setItem("mwcrm_menu_custom", "1"); localStorage.setItem("mwcrm_menu_order", JSON.stringify(order)); localStorage.setItem("mwcrm_menu_hidden", JSON.stringify(hidden)); };
  const [menuGroups, setMenuGroups] = useState(() => { try { return JSON.parse(localStorage.getItem("mwcrm_menu_groups") || "[]"); } catch { return []; } });
  const [menuTop, setMenuTop] = useState(() => { try { return JSON.parse(localStorage.getItem("mwcrm_menu_top") || '["/hizli-ekle"]'); } catch { return ["/hizli-ekle"]; } });
  const topItems = NAV.filter((n) => menuTop.includes(n.to) && (!n.admin || isAdmin) && (!n.super || isSuperAdmin) && (isSuperAdmin || ((!n.sec || !perms?.sections || perms.sections.includes(n.sec)) && !(perms?.hidden_pages || []).includes(n.to))));
  const dropTop = (e) => { const v = e.dataTransfer.getData("text/plain"); if (!v.startsWith("mwnav:")) return; e.preventDefault(); const add = v.slice(6).split("|").filter((x) => x && !menuTop.includes(x)); if (add.length) saveTop([...menuTop, ...add]); setBarOpen(actionBarsRef.current[0] || "layout-kisayol"); };
  const dropRef = useRef(null);
  dropRef.current = dropTop;
  const saveTop = (t) => { menuDirty.current = true; setMenuTop(t); localStorage.setItem("mwcrm_menu_custom", "1"); localStorage.setItem("mwcrm_menu_top", JSON.stringify(t)); };
  const [menuAssign, setMenuAssign] = useState(() => { try { return JSON.parse(localStorage.getItem("mwcrm_menu_assign") || "{}"); } catch { return {}; } });
  const [openGroups, setOpenGroups] = useState(() => { try { return JSON.parse(localStorage.getItem("mwcrm_menu_open") || "{}"); } catch { return {}; } });
  const [newGroup, setNewGroup] = useState("");
  const saveGroups = (g) => { menuDirty.current = true; setMenuGroups(g); localStorage.setItem("mwcrm_menu_custom", "1"); localStorage.setItem("mwcrm_menu_groups", JSON.stringify(g)); };
  const saveAssign = (a) => { menuDirty.current = true; setMenuAssign(a); localStorage.setItem("mwcrm_menu_custom", "1"); localStorage.setItem("mwcrm_menu_assign", JSON.stringify(a)); };
  const applyMenu = (m) => {
    const o = m.order || [], h = m.hidden || [], g = m.groups || [], a = m.assign || {};
    localStorage.setItem("mwcrm_menu_order", JSON.stringify(o)); localStorage.setItem("mwcrm_menu_hidden", JSON.stringify(h));
    localStorage.setItem("mwcrm_menu_groups", JSON.stringify(g)); localStorage.setItem("mwcrm_menu_assign", JSON.stringify(a));
    const t = Array.isArray(m.top) ? m.top : ["/hizli-ekle"];
    localStorage.setItem("mwcrm_menu_top", JSON.stringify(t)); setMenuTop(t);
    setMenuOrder(o); setMenuHidden(h); setMenuGroups(g); setMenuAssign(a);
  };
  useEffect(() => {
    api.get("/menu-tenant", { silent: true }).then((r) => {
      if (r.data?.updated_at) return applyMenu(r.data);
      if (localStorage.getItem("mwcrm_menu_custom") === "1") return;
      api.get("/menu-default", { silent: true }).then((x) => { if (x.data?.updated_at) applyMenu(x.data); }).catch(() => {});
    }).catch(() => {});
  }, [selectedTenant]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!menuDirty.current || !menuAdmin) return;
    const t = setTimeout(() => {
      menuDirty.current = false;
      api.put("/menu-tenant", { data: { top: menuTop, order: menuOrder, hidden: menuHidden, groups: menuGroups, assign: menuAssign } }, { silent: true })
        .then(() => toast.success("MENÜ KAYDEDİLDİ — FİRMADAKİ HERKES BU MENÜYÜ GÖRÜR", { id: "menu-saved" })).catch(() => {});
    }, 700);
    return () => clearTimeout(t);
  }, [menuTop, menuOrder, menuHidden, menuGroups, menuAssign, menuAdmin]);
  const [dropOver, setDropOver] = useState("");
  const [addingGroup, setAddingGroup] = useState(false);
  const [menuScope, setMenuScope] = useState("");
  const [menuScopes, setMenuScopes] = useState([]);
  useEffect(() => { if (isSuperAdmin && editMenu) api.get("/menu-default/groups", { silent: true }).then((r) => setMenuScopes(r.data)).catch(() => {}); }, [isSuperAdmin, editMenu]);
  const changeScope = async (g) => {
    setMenuScope(g);
    const r = await api.get("/menu-default", { params: { group: g }, silent: true }).catch(() => null);
    if (r?.data?.updated_at) applyMenu(r.data); else if (g) toast.info("BU GRUBA ÖZEL MENÜ YOK — MEVCUT DÜZENİ KAYDEDEBİLİRSİNİZ");
  };
  const publishMenu = async () => {
    try {
      await api.put("/menu-default", { data: { top: menuTop, order: menuOrder, hidden: menuHidden, groups: menuGroups, assign: menuAssign, group_id: menuScope } });
      toast.success(menuScope ? `MENÜ ${menuScopes.find((s) => s.id === menuScope)?.name || ""} GRUBU İÇİN VARSAYILAN YAPILDI` : "MENÜ HERKES İÇİN VARSAYILAN YAPILDI");
      if (isSuperAdmin) api.get("/menu-default/groups", { silent: true }).then((r) => setMenuScopes(r.data)).catch(() => {});
    } catch (e) { toast.error(e.response?.data?.detail || "HATA"); }
  };
  const removeScopeMenu = async () => {
    await api.delete(`/menu-default/${menuScope}`).catch(() => null);
    toast.success("GRUP MENÜSÜ SİLİNDİ — GENEL ANA DEPO MENÜSÜ KULLANILACAK");
    setMenuScopes((s) => s.map((x) => (x.id === menuScope ? { ...x, has_menu: false } : x)));
  };
  const resetMenu = async () => {
    localStorage.removeItem("mwcrm_menu_custom");
    const r = await api.get("/menu-default", { silent: true }).catch(() => null);
    applyMenu(r?.data?.updated_at ? r.data : {}); toast.success("ANA DEPO MENÜSÜNE DÖNÜLDÜ");
  };
  const toggleGroupOpen = (id) => setOpenGroups((o) => { const n = { ...o, [id]: o[id] === false ? true : false }; localStorage.setItem("mwcrm_menu_open", JSON.stringify(n)); return n; });
  const [menuFont, setMenuFont] = useState(() => parseInt(localStorage.getItem("mwcrm_menu_fontsize")) || 16);
  useEffect(() => {
    const reload = () => {
      try {
        setMenuOrder(JSON.parse(localStorage.getItem("mwcrm_menu_order") || "[]"));
        setMenuHidden(JSON.parse(localStorage.getItem("mwcrm_menu_hidden") || "[]"));
        setMenuGroups(JSON.parse(localStorage.getItem("mwcrm_menu_groups") || "[]"));
        setMenuAssign(JSON.parse(localStorage.getItem("mwcrm_menu_assign") || "{}"));
        setMenuTop(JSON.parse(localStorage.getItem("mwcrm_menu_top") || '["/hizli-ekle"]'));
        setOpenGroups(JSON.parse(localStorage.getItem("mwcrm_menu_open") || "{}"));
      } catch (e) {}
      setMenuFont(parseInt(localStorage.getItem("mwcrm_menu_fontsize")) || 16);
    };
    window.addEventListener("mw-menu-config", reload);
    return () => window.removeEventListener("mw-menu-config", reload);
  }, []);

  const toggleTheme = () => {
    const next = !light;
    setLight(next);
    document.documentElement.classList.toggle("light", next);
    localStorage.setItem("mwcrm_theme", next ? "light" : "dark");
  };

  const applyZoom = (v) => {
    const z = Math.min(1.1, Math.max(0.5, Math.round(v * 100) / 100));
    setZoom(z);
    localStorage.setItem("mwcrm_zoom", String(z));
  };

  useEffect(() => {
    const el = document.documentElement;
    if (rowH) { el.classList.add("density-custom"); el.style.setProperty("--mw-row", rowH + "px"); }
    else { el.classList.remove("density-custom"); el.style.removeProperty("--mw-row"); }
  }, [rowH]);
  const applyRowH = (v) => { const n = v ? Math.min(44, Math.max(12, v)) : 0; setRowH(n); localStorage.setItem("mwcrm_rowh", String(n)); window.dispatchEvent(new Event("mw-rowh")); };

  useEffect(() => {
    api.get("/tenant/ui", { silent: true }).then((r) => {
      const ui = r.data || {};
      if (ui.bars_open !== undefined) localStorage.setItem("mwcrm_cb_default", ui.bars_open ? "1" : "0");
      if (ui.rowh !== undefined) { localStorage.setItem("mwcrm_rowh", String(ui.rowh)); setRowH(ui.rowh); }
    }).catch(() => {});
  }, [selectedTenant]);

  useEffect(() => {
    api.get("/meta/version", { silent: true }).then((r) => setVersion(r.data.version)).catch(() => {});
  }, []);

  useEffect(() => { if (!isSuperAdmin && user) api.get("/org/branches", { silent: true }).then((r) => setOrgBranches(r.data || [])).catch(() => {}); }, [isSuperAdmin, user]);
  useEffect(() => {
    if (isSuperAdmin) api.get("/firms", { silent: true }).then((r) => setFirms(r.data)).catch(() => {});
  }, [isSuperAdmin]);

  useEffect(() => {
    const poll = () => {
      api.get("/tasks/due", { silent: true }).then((r) => {
        (r.data || []).forEach((t) => {
          const when = t.due_at ? new Date(t.due_at).toLocaleString("tr-TR") : "";
          toast.info(`⏰ RANDEVU: ${t.title}`, { description: `${when}${t.note ? " · " + t.note : ""}`, duration: 15000 });
        });
      }).catch(() => {});
    };
    poll();
    const iv = setInterval(poll, 60000);
    return () => clearInterval(iv);
  }, []);

  useEffect(() => {
    if (!selectedTenant && !tenantInfo?.name) return;
    if (!sessionStorage.getItem("mw_price_alert")) {
      api.get("/ambar-alerts", { silent: true }).then((r) => {
        const l = r.data || []; if (!l.length) return;
        sessionStorage.setItem("mw_price_alert", "1");
        const exp = l.filter((x) => x.kalan !== null && x.kalan < 0).length;
        toast.warning(`FİYAT HATIRLATMA: ${exp} FİYATIN SÜRESİ DOLDU, ${l.length - exp} FİYAT YAKINDA DOLACAK / TARİHSİZ`, { duration: 20000, action: { label: "GÖSTER", onClick: () => navigate("/ambarlar") } });
      }).catch(() => {});
    }
    const key = "mw_loads_seen"; if (!localStorage.getItem(key)) localStorage.setItem(key, new Date().toISOString());
    const poll = () => api.get("/load-board/new", { params: { since: localStorage.getItem(key) }, silent: true }).then((r) => {
      const l = r.data || []; if (!l.length) return;
      localStorage.setItem(key, l[0].created_at);
      l.slice(0, 5).forEach((x) => toast.info(`YENİ İLAN (${x.kind}): ${x.from_il} → ${x.to_il}`, { description: `${x.yuk || ""} ${x.tonaj || ""} ${x.arac || ""} ${x.fiyat ? "· " + x.fiyat : ""} · ${x.ad || ""} ${x.tel || ""}`, duration: 15000, action: { label: "AÇ / GÖNDER", onClick: () => navigate("/ambarlar?tab=load") } }));
    }).catch(() => {});
    const qk = "mw_quotes_seen"; if (!localStorage.getItem(qk)) localStorage.setItem(qk, new Date().toISOString());
    const pollQ = () => api.get("/portal-quotes/new", { params: { since: localStorage.getItem(qk) }, silent: true }).then((r) => {
      const l = r.data || []; if (!l.length) return;
      localStorage.setItem(qk, l[0].at);
      l.slice(0, 5).forEach((x) => {
        const tel = (x.musteri_tel || "").replace(/^0/, "90").replace(/^(\d{10})$/, "90$1");
        toast.success(`FİYAT TALEBİ: ${x.musteri || "MÜŞTERİ"} → ${x.il} ${x.adet} ${x.kargo_turu}`, { description: `${x.desi ? x.desi + " DESİ " : ""}${x.kg ? x.kg + " KG " : ""}· ÇIKAN FİYAT: ${x.fiyat != null ? Number(x.fiyat).toLocaleString("tr-TR") : "FİYAT YOK"}${x.musteri_tel ? " · " + x.musteri_tel : ""}`, duration: 30000,
          cancel: { label: "LİSTE", onClick: () => navigate("/ambarlar?tab=quote") },
          action: tel ? { label: "WHATSAPP", onClick: () => window.open(`https://wa.me/${tel}?text=${encodeURIComponent(`MERHABA ${x.musteri}, ${x.il} ${x.adet} ${x.kargo_turu} FİYAT TALEBİNİZİ ALDIK.`)}`, "_blank") } : undefined });
      });
    }).catch(() => {});
    const dk = "mw_doc_alert";
    const uk = "mw_unread_alert"; if (!sessionStorage.getItem(uk)) { sessionStorage.setItem(uk, "1"); api.get("/invoices-unread", { silent: true }).then((r) => { if (r.data?.count) toast.warning(`FATURA: ${r.data.count} FATURA 3 GÜNDÜR MÜŞTERİ TARAFINDAN AÇILMADI`, { id: "unread-alert", duration: 20000, action: { label: "GÖSTER", onClick: () => navigate("/faturalar?durum=OKUNMADI") } }); }).catch(() => sessionStorage.removeItem(uk)); }
    const ck = "mw_cek_alert";
    const mk = "mw_mtb_alert"; if (!sessionStorage.getItem(mk)) { sessionStorage.setItem(mk, "1"); api.get("/reconcile/pending", { silent: true }).then((r) => { if (r.data?.count) toast.warning(`MUTABAKAT: ${r.data.month} DÖNEMİNDE ONAY BEKLEYEN ${r.data.count} FİRMA ÇİFTİ VAR`, { id: "mtb-alert", duration: 20000, action: { label: "GÖSTER", onClick: () => navigate(`/grup-panosu?ay=${r.data.month}`) } }); }).catch(() => sessionStorage.removeItem(mk)); } if (!sessionStorage.getItem(ck)) { sessionStorage.setItem(ck, "1"); api.get("/cheques", { params: { days: 3 }, silent: true }).then((r) => { if (r.data?.length) toast.warning(`ÇEK VADE: ${r.data.length} ÇEKİN VADESİ 3 GÜN İÇİNDE / GEÇMİŞ`, { id: "cek-alert", duration: 20000, action: { label: "GÖSTER", onClick: () => navigate("/cekler") } }); }).catch(() => sessionStorage.removeItem(ck)); }
    if (!sessionStorage.getItem(dk)) api.get("/carrier-doc-alerts", { silent: true }).then((r) => { if (r.data?.length) { sessionStorage.setItem(dk, "1"); toast.warning(`EVRAK HATIRLATMA: ${r.data.length} NAKLİYECİNİN EVRAKI DOLDU / DOLACAK`, { duration: 20000, action: { label: "HATIRLAT", onClick: () => navigate("/ambarlar?tab=car") } }); } }).catch(() => {});
    const all = () => { poll(); pollQ(); };
    all(); const iv = setInterval(all, 30000); return () => clearInterval(iv);
  }, [selectedTenant, tenantInfo?.name]); // eslint-disable-line

  const doLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="flex min-h-screen bg-slate-950">
      <LoadingOverlay />
      {/* Sidebar */}
      {mobile && drawer && <div data-testid="drawer-overlay" onClick={() => setDrawer(false)} className="fixed inset-0 z-40 bg-black/50" />}
      <aside
        data-testid="sidebar"
        className={`${mobile ? `fixed inset-y-0 left-0 z-50 w-72 transition-transform duration-200 ${drawer ? "translate-x-0" : "-translate-x-full"}` : `sticky top-0 z-30 transition-all duration-300 ${collapsed ? "w-[72px]" : "w-64"}`} flex h-screen flex-col border-r border-slate-800 bg-slate-900`}
      >
        <div className="flex h-16 items-center gap-2 border-b border-slate-800 px-4">
          <BrandMark brand={tenantInfo?.name ? tenantInfo : null} size={collapsed ? 34 : 38} maxW={collapsed ? 40 : 150} />
          {!collapsed && <BrandName brand={tenantInfo?.name ? tenantInfo : null} />}
        </div>

        <nav className="flex-1 space-y-1 overflow-y-auto p-3" onDragOver={(e) => e.preventDefault()} onDrop={(e) => { const v = e.dataTransfer.getData("text/plain"); if (v.startsWith("mwtop:")) saveTop(menuTop.filter((x) => x !== v.slice(6))); }}>
          {(() => {
            const baseNav = NAV.filter((n) => (!n.admin || isAdmin) && (!n.super || isSuperAdmin) && (isSuperAdmin || ((!n.sec || !perms || !perms.sections || perms.sections.includes(n.sec)) && !(perms?.hidden_pages || []).includes(n.to))));
            const orderIdx = (to) => { const i = menuOrder.indexOf(to); return i === -1 ? 999 : i; };
            const orderedNav = baseNav.map((n, i) => ({ n, i })).sort((a, b) => (orderIdx(a.n.to) - orderIdx(b.n.to)) || (a.i - b.i)).map((x) => x.n);
            const shownNav = editMenu ? orderedNav : orderedNav.filter((n) => !menuHidden.includes(n.to) && !menuTop.includes(n.to));
            const tid = (to) => (to === "/" ? "dashboard" : to.slice(1));
            const onDropItem = (targetTo) => {
              const from = dragRef.current; dragRef.current = null;
              if (!from || from === targetTo) return;
              const cur = orderedNav.map((n) => n.to);
              const fi = cur.indexOf(from), ti = cur.indexOf(targetTo);
              if (fi < 0 || ti < 0) return;
              cur.splice(fi, 1); cur.splice(ti, 0, from);
              setMenuOrder(cur); persistMenu(cur, menuHidden);
            };
            const moveItem = (from, before, gid) => {
              const cur = orderedNav.map((x) => x.to).filter((x) => x !== from);
              const ti = before ? cur.indexOf(before) : -1;
              cur.splice(ti < 0 ? cur.length : ti, 0, from);
              setMenuOrder(cur); persistMenu(cur, menuHidden);
              const a = { ...menuAssign }; if (gid) a[from] = gid; else delete a[from]; saveAssign(a);
            };
            const addGroup = (label) => { const l = label.trim().toLocaleUpperCase("tr-TR"); if (l) saveGroups([...menuGroups, { id: "g" + Date.now(), label: l }]); setNewGroup(""); setAddingGroup(false); };
            const toggleHide = (to) => { const h = menuHidden.includes(to) ? menuHidden.filter((x) => x !== to) : [...menuHidden, to]; setMenuHidden(h); persistMenu(menuOrder, h); };

            const NavItem = (n) => {
              const Icon = n.icon;
              return (
                <NavLink key={n.to} to={n.to} end={n.end} onClick={navClick} data-testid={`nav-${tid(n.to)}-link`}
                  draggable={!editMenu} onDragStart={(e) => { dragRef.current = n.to; e.dataTransfer.setData("text/plain", `mwnav:${n.to}`); }} onDragEnd={() => { dragRef.current = null; setDropOver(""); }}
                  onDragOver={(e) => { if (menuAdmin && dragRef.current && !String(dragRef.current).startsWith("g:") && dragRef.current !== n.to) { e.preventDefault(); setDropOver(n.to); } }}
                  onDragLeave={() => setDropOver((d) => (d === n.to ? "" : d))}
                  onDrop={(e) => { const from = dragRef.current; if (!menuAdmin || !from || String(from).startsWith("g:")) return; e.preventDefault(); e.stopPropagation(); setDropOver(""); moveItem(from, n.to, menuAssign[n.to] || ""); }}
                  className={({ isActive }) => `nav-link flex items-center gap-3 rounded-lg px-3 ${mobile ? "py-3 text-base" : "py-2.5 text-sm"} font-semibold ${dropOver === n.to ? "border-t-2 border-emerald-400" : ""} ${menuAdmin ? "cursor-grab" : ""} ${isActive ? "bg-blue-500/15 text-blue-300 ring-1 ring-blue-500/30" : "text-slate-400 hover:bg-slate-800 hover:text-slate-100"}`}
                  title={n.label}>
                  <Icon className="h-[18px] w-[18px] shrink-0" />
                  {!collapsed && <span className="truncate">{n.label}</span>}
                </NavLink>
              );
            };

            // ---- EDIT MODE: grup yönetimi + sürüklenebilir liste + grup ataması ----
            if (editMenu && !collapsed) {
              return (
                <div className="space-y-2">
                  {isSuperAdmin && (
                    <div className="flex items-center gap-1">
                      <select data-testid="menu-scope-select" value={menuScope} onChange={(e) => changeScope(e.target.value)} className="h-7 min-w-0 flex-1 rounded border border-slate-600 bg-slate-900 px-1 text-[10px] font-bold text-slate-200">
                        <option value="">GENEL (TÜM FİRMALAR)</option>
                        {menuScopes.map((g) => <option key={g.id} value={g.id}>GRUP: {g.name}{g.has_menu ? " ✓" : ""}</option>)}
                      </select>
                      {menuScope && menuScopes.find((s) => s.id === menuScope)?.has_menu && <button data-testid="menu-scope-delete" onClick={removeScopeMenu} className="rounded border border-rose-700 px-1.5 py-1 text-[10px] font-bold text-rose-300">SİL</button>}
                    </div>
                  )}
                  <div className="flex flex-wrap gap-1">
                    {isSuperAdmin && <button data-testid="menu-publish-default" onClick={publishMenu} className="flex-1 rounded bg-emerald-600 px-2 py-1 text-[10px] font-bold text-white hover:bg-emerald-700">{menuScope ? "BU GRUBA UYGULA (VARSAYILAN)" : "HERKESE UYGULA (VARSAYILAN)"}</button>}
                    <button data-testid="menu-reset-default" onClick={resetMenu} className="flex-1 rounded border border-slate-600 px-2 py-1 text-[10px] font-bold text-slate-300 hover:bg-slate-800">ANA DEPO MENÜSÜNE DÖN</button>
                  </div>
                  <div className="rounded-lg border border-slate-700 bg-slate-800/40 p-2">
                    <div className="mb-1 text-[10px] font-bold uppercase text-slate-400">ÜST MENÜLER</div>
                    {menuGroups.map((g) => (
                      <div key={g.id} className="mb-1 flex items-center gap-1">
                        <FolderPlus className="h-3.5 w-3.5 shrink-0 text-amber-400" />
                        <input data-testid={`group-name-${g.id}`} value={g.label} onChange={(e) => saveGroups(menuGroups.map((x) => x.id === g.id ? { ...x, label: e.target.value.toLocaleUpperCase("tr-TR") } : x))} className="h-6 flex-1 rounded border border-slate-700 bg-slate-900 px-1 text-[11px] text-slate-100" />
                        <button data-testid={`group-del-${g.id}`} onClick={() => { saveGroups(menuGroups.filter((x) => x.id !== g.id)); const a = { ...menuAssign }; Object.keys(a).forEach((k) => { if (a[k] === g.id) delete a[k]; }); saveAssign(a); }} className="rounded p-0.5 text-slate-400 hover:text-rose-400"><X className="h-3.5 w-3.5" /></button>
                      </div>
                    ))}
                    <div className="mt-1 flex items-center gap-1">
                      <input data-testid="group-new-input" value={newGroup} onChange={(e) => setNewGroup(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter" && newGroup.trim()) { saveGroups([...menuGroups, { id: "g" + Date.now(), label: newGroup.trim().toLocaleUpperCase("tr-TR") }]); setNewGroup(""); } }} placeholder="YENİ ÜST MENÜ ADI" className="h-6 flex-1 rounded border border-slate-700 bg-slate-900 px-1 text-[11px] text-slate-100 placeholder:text-slate-500" />
                      <button data-testid="group-add-btn" onClick={() => { if (newGroup.trim()) { saveGroups([...menuGroups, { id: "g" + Date.now(), label: newGroup.trim().toLocaleUpperCase("tr-TR") }]); setNewGroup(""); } }} className="rounded bg-blue-600 p-1 text-white hover:bg-blue-700"><Plus className="h-3.5 w-3.5" /></button>
                    </div>
                  </div>
                  {shownNav.map((n) => {
                    const Icon = n.icon; const hidden = menuHidden.includes(n.to);
                    return (
                      <div key={n.to} data-testid={`menu-edit-${tid(n.to)}`} draggable
                        onDragStart={() => { dragRef.current = n.to; }} onDragOver={(e) => e.preventDefault()} onDrop={() => onDropItem(n.to)}
                        className={`flex cursor-move items-center gap-1.5 rounded-lg border border-dashed border-slate-700 px-2 py-1.5 text-sm font-semibold ${hidden ? "opacity-40" : "text-slate-200"}`}>
                        <GripVertical className="h-4 w-4 shrink-0 text-slate-500" />
                        <Icon className="h-[16px] w-[16px] shrink-0" />
                        <span className="flex-1 truncate text-[12px]">{n.label}</span>
                        <select data-testid={`menu-group-sel-${tid(n.to)}`} value={menuAssign[n.to] || ""} onChange={(e) => { const a = { ...menuAssign }; if (e.target.value) a[n.to] = e.target.value; else delete a[n.to]; saveAssign(a); }} className="h-6 w-20 rounded border border-slate-700 bg-slate-900 text-[10px] text-slate-100">
                          <option value="">— ÜST YOK —</option>
                          {menuGroups.map((g) => <option key={g.id} value={g.id}>{g.label}</option>)}
                        </select>
                        <button data-testid={`menu-top-${tid(n.to)}`} onClick={() => saveTop(menuTop.includes(n.to) ? menuTop.filter((x) => x !== n.to) : [...menuTop, n.to])} title={menuTop.includes(n.to) ? "SOL MENÜYE AL" : "ÜST İŞLEMLERE AL"} className={`rounded p-0.5 hover:bg-slate-700 ${menuTop.includes(n.to) ? "text-emerald-400" : "text-slate-400 hover:text-slate-100"}`}>
                          <ArrowUpToLine className="h-4 w-4" />
                        </button>
                        <button data-testid={`menu-hide-${tid(n.to)}`} onClick={() => toggleHide(n.to)} title={hidden ? "GÖSTER" : "GİZLE"} className="rounded p-0.5 text-slate-400 hover:bg-slate-700 hover:text-slate-100">
                          {hidden ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                        </button>
                      </div>
                    );
                  })}
                </div>
              );
            }

            // ---- NORMAL MODE ----
            if (collapsed) return shownNav.map((n) => NavItem(n));
            const blocks = []; const gb = {};
            shownNav.forEach((n) => {
              const gid = menuAssign[n.to];
              const grp = gid && menuGroups.find((g) => g.id === gid);
              if (!grp) blocks.push({ type: "item", n });
              else { if (!gb[gid]) { gb[gid] = { type: "group", grp, items: [] }; blocks.push(gb[gid]); } gb[gid].items.push(n); }
            });
            menuGroups.forEach((g) => { if (!gb[g.id]) { gb[g.id] = { type: "group", grp: g, items: [] }; blocks.unshift(gb[g.id]); } });
            const groupDrop = (gid) => ({
              onDragOver: (e) => { if (menuAdmin && dragRef.current) { e.preventDefault(); setDropOver("g:" + gid); } },
              onDragLeave: () => setDropOver((d) => (d === "g:" + gid ? "" : d)),
              onDrop: (e) => { const from = dragRef.current; if (!menuAdmin || !from) return; e.preventDefault(); e.stopPropagation(); setDropOver("");
                if (String(from).startsWith("g:")) {
                  const src = from.slice(2); if (src === gid) return;
                  const mv = (gb[src]?.items || []).map((x) => x.to);
                  const cur = orderedNav.map((x) => x.to).filter((x) => !mv.includes(x));
                  const all = orderedNav.map((x) => x.to); const tItems = (gb[gid]?.items || []).map((x) => x.to);
                  const down = mv.length && tItems.length && all.indexOf(mv[0]) < all.indexOf(tItems[0]);
                  const anchor = down ? tItems[tItems.length - 1] : tItems[0];
                  const pos = anchor ? cur.indexOf(anchor) + (down ? 1 : 0) : 0; cur.splice(pos, 0, ...mv);
                  setMenuOrder(cur); persistMenu(cur, menuHidden);
                  const g = menuGroups.filter((x) => x.id !== src); const ti = g.findIndex((x) => x.id === gid); g.splice(ti < 0 ? 0 : ti, 0, menuGroups.find((x) => x.id === src)); saveGroups(g);
                  return;
                } const items = gb[gid]?.items || []; const cur = orderedNav.map((x) => x.to).filter((x) => x !== from); const pos = items.length ? cur.indexOf(items[items.length - 1].to) + 1 : 0; cur.splice(pos, 0, from); setMenuOrder(cur); persistMenu(cur, menuHidden); const a = { ...menuAssign, [from]: gid }; saveAssign(a); setOpenGroups((o) => ({ ...o, [gid]: true })); },
            });
            return (<>
              {blocks.map((b) => {
                if (b.type === "item") return NavItem(b.n);
                const open = openGroups[b.grp.id] !== false;
                return (
                  <div key={b.grp.id} className="space-y-1" {...groupDrop(b.grp.id)}>
                    <div className={`group/gh flex items-center rounded-lg hover:bg-slate-800 ${dropOver === "g:" + b.grp.id ? "ring-2 ring-emerald-400" : ""}`}>
                      <button data-testid={`group-header-${b.grp.id}`} draggable onDragStart={(e) => { dragRef.current = "g:" + b.grp.id; e.dataTransfer.setData("text/plain", `mwnav:${b.items.map((x) => x.to).join("|")}`); }} onDragEnd={() => { dragRef.current = null; setDropOver(""); }} title={menuAdmin ? "TIKLA: AÇ/KAPAT · ÇİFT TIKLA: ADINI DEĞİŞTİR · BAŞLIĞI SÜRÜKLE: ÜST MENÜ SIRASINI DEĞİŞTİR · MENÜLERİ BURAYA SÜRÜKLEYİN" : "AÇ / KAPAT"} onClick={() => toggleGroupOpen(b.grp.id)}
                        onDoubleClick={() => { if (!menuAdmin) return; const l = window.prompt("ÜST MENÜ ADI", b.grp.label); if (l && l.trim()) saveGroups(menuGroups.map((x) => (x.id === b.grp.id ? { ...x, label: l.trim().toLocaleUpperCase("tr-TR") } : x))); }}
                        className="mw-grouphead flex min-w-0 flex-1 items-center gap-2 px-3 py-2 font-extrabold uppercase tracking-wider" style={{ fontSize: menuFont }}>
                        {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
                        <span className="truncate">{b.grp.label}</span>
                        <span className="ml-auto text-[10px] font-bold text-slate-500">{b.items.length}</span>
                      </button>
                      
                    </div>
                    {open && <div className="ml-2 min-h-[8px] space-y-1 border-l border-slate-800 pl-1">{b.items.length ? b.items.map((n) => NavItem(n)) : menuAdmin && <div className="px-2 py-1 text-[10px] text-slate-500">MENÜLERİ BURAYA SÜRÜKLEYİN</div>}</div>}
                  </div>
                );
              })}
              {menuAdmin && (
                <div data-testid="menu-ungroup-zone" onDragOver={(e) => { if (dragRef.current && !String(dragRef.current).startsWith("g:")) { e.preventDefault(); setDropOver("free"); } }} onDragLeave={() => setDropOver((d) => (d === "free" ? "" : d))}
                  onDrop={(e) => { const from = dragRef.current; if (!from || String(from).startsWith("g:")) return; e.preventDefault(); e.stopPropagation(); setDropOver(""); moveItem(from, "", ""); }}
                  className={`mt-2 rounded-lg border border-dashed px-2 py-2 ${dropOver === "free" ? "border-emerald-400 bg-emerald-500/10" : "border-slate-700"}`}>
                  {addingGroup ? (
                    <div className="flex items-center gap-1">
                      <input autoFocus data-testid="menu-new-group-input" value={newGroup} onChange={(e) => setNewGroup(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") addGroup(newGroup); if (e.key === "Escape") setAddingGroup(false); }} placeholder="ÜST MENÜ ADI" className="h-7 min-w-0 flex-1 rounded border border-slate-600 bg-slate-950 px-2 text-xs text-slate-100" />
                      <button data-testid="menu-new-group-save" onClick={() => addGroup(newGroup)} className="rounded bg-emerald-600 p-1 text-white"><Check className="h-4 w-4" /></button>
                    </div>
                  ) : (
                    <button data-testid="menu-new-group-button" onClick={() => setAddingGroup(true)} className="flex w-full items-center gap-2 text-xs font-bold text-slate-400 hover:text-emerald-300"><FolderPlus className="h-4 w-4" /> YENİ ÜST MENÜ</button>
                  )}
                  <div className="mt-1 text-[10px] leading-tight text-slate-500">SÜRÜKLE: SIRALA · ÜST MENÜYE BIRAK: İÇİNE AT · ÜST MENÜ BAŞLIĞINI BAŞKA BAŞLIĞA BIRAK: YER DEĞİŞTİR · BURAYA BIRAK: ÜST MENÜDEN ÇIKAR · KALDIRMA: AYARLAR</div>
                </div>
              )}
            </>);
          })()}
        </nav>

        <div className="border-t border-slate-800 p-3">
          {!collapsed && (
            <div className="mb-2 px-1">
              <div className="truncate text-sm font-semibold text-slate-200">{user?.name}</div>
              {isSuperAdmin && <div data-testid="maker-admin-badge" className="truncate text-[11px] font-bold text-amber-300"><span className="text-amber-400">★★★★★</span> YAPIMCI ADMIN</div>}
              <div className="truncate text-xs text-slate-500">@{user?.username || user?.name}</div>
              <div className="mt-1 font-mono text-[10px] text-slate-600">SÜRÜM {version}</div>
            </div>
          )}
          <ChangePassword collapsed={collapsed} />
          <button
            data-testid="logout-button"
            onClick={doLogout}
            className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-semibold text-rose-400 hover:bg-rose-500/10"
          >
            <LogOut className="h-[18px] w-[18px]" />
            {!collapsed && <span>ÇIKIŞ</span>}
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="flex min-w-0 flex-1 flex-col">
        <BarCtx.Provider value={barCtx}>
        <div className="glass sticky top-0 z-20 border-b border-slate-800">
        <header className="flex h-12 items-center gap-2 px-2 md:gap-3 md:px-4">
          <button
            data-testid="sidebar-toggle"
            onClick={() => setCollapsed((c) => !c)}
            className="flex h-9 w-9 items-center justify-center rounded-lg border border-slate-700 text-slate-300 hover:bg-slate-800"
          >
            {mobile ? <Menu className="h-5 w-5" /> : collapsed ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
          </button>
          <div ref={barRefs.title} data-testid="bar-title-slot" className="flex min-w-0 shrink items-center gap-2 overflow-hidden" />
          <div ref={barRefs.toggles} data-testid="bar-toggle-slot" className="ml-auto flex min-w-0 shrink items-center gap-2 overflow-x-auto md:shrink-0 md:overflow-visible" />
          <div className="flex min-w-0 shrink items-center gap-3 md:shrink-0">
            <CollapseBar id="topbar" label={`${(firms.find((f) => f.id === selectedTenant) || {}).name || tenantInfo?.name || "FİRMA"} · ${year === "all" ? "TÜM YILLAR" : year}`} className="justify-end">
            {isSuperAdmin && (
              <select data-testid="firm-selector" value={selectedTenant} onChange={(e) => setTenant(e.target.value)} className="h-9 rounded-lg border border-slate-700 bg-slate-800 px-2 text-sm text-slate-100">
                <option value="">FİRMA SEÇ…</option>
                {firms.map((f) => <option key={f.id} value={f.id}>{f.name}</option>)}
              </select>
            )}
            {!isSuperAdmin && orgBranches.length > 1 && orgBranches.find((b) => b.is_root)?.id === user?.tenant_id && (
              <select data-testid="branch-selector" value={tenantInfo?.tenant_id || ""} onChange={(e) => setTenant(e.target.value === user?.tenant_id ? "" : e.target.value)} className="h-9 rounded-lg border border-sky-700 bg-slate-800 px-2 text-sm font-semibold text-sky-200">
                {orgBranches.map((b) => <option key={b.id} value={b.id}>{b.is_root ? "MERKEZ · " : "ŞUBE · "}{b.name}</option>)}
              </select>
            )}
            {!isSuperAdmin && !(orgBranches.length > 1 && orgBranches.find((b) => b.is_root)?.id === user?.tenant_id) && tenantInfo?.name && (
              <span data-testid="firm-name" className="hidden rounded-lg border border-slate-700 px-3 py-1.5 text-xs font-semibold text-blue-300 md:block">{tenantInfo.name}</span>
            )}
            <select data-testid="year-selector" value={year} onChange={(e) => setYear(e.target.value)} className="h-9 rounded-lg border border-slate-700 bg-slate-800 px-2 text-sm text-slate-100">
              {YEARS.map((y) => <option key={y} value={y}>{y === "all" ? "TÜM YILLAR" : y}</option>)}
            </select>
            <div className="flex items-center gap-0.5 rounded-lg border border-slate-700 px-1">
              <button data-testid="zoom-out" onClick={() => applyZoom(zoom - 0.1)} title="UZAKLAŞTIR" className="rounded p-1.5 text-slate-300 hover:bg-slate-800">
                <ZoomOut className="h-4 w-4" />
              </button>
              <span data-testid="zoom-level" className="w-10 text-center text-xs font-semibold text-slate-400">{Math.round(zoom * 100)}%</span>
              <button data-testid="zoom-in" onClick={() => applyZoom(zoom + 0.1)} title="YAKINLAŞTIR" className="rounded p-1.5 text-slate-300 hover:bg-slate-800">
                <ZoomIn className="h-4 w-4" />
              </button>
              <button data-testid="zoom-fit" onClick={() => applyZoom(0.8)} title="EKRANA SIĞDIR" className="rounded p-1.5 text-slate-300 hover:bg-slate-800">
                <Minimize2 className="h-4 w-4" />
              </button>
            </div>
            <div className="flex h-9 items-center gap-1.5 rounded-lg border border-slate-700 px-2" title="SATIR YÜKSEKLİĞİ — SİZ AYARLAYIN (TÜM TABLOLAR)">
              <Rows3 className="h-4 w-4 text-slate-300" />
              <input data-testid="rowh-slider" type="range" min="12" max="44" value={rowH || 36} onChange={(e) => applyRowH(parseInt(e.target.value))} className="h-1 w-24 cursor-pointer accent-emerald-500" />
              <span data-testid="rowh-value" className="w-9 text-center text-xs font-semibold text-slate-400">{rowH ? rowH + "px" : "OFF"}</span>
              <button data-testid="rowh-reset" onClick={() => applyRowH(0)} title="NORMALE DÖN" className="rounded p-0.5 text-slate-400 hover:text-slate-200"><Rows2 className="h-4 w-4" /></button>
            </div>
            <button
              data-testid="theme-toggle"
              onClick={toggleTheme}
              title={light ? "GECE MODU" : "GÜNDÜZ MODU"}
              className="flex h-9 w-9 items-center justify-center rounded-lg border border-slate-700 text-slate-300 hover:bg-slate-800"
            >
              {light ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
            </button>
            <span className="text-xs text-slate-500">
              {new Date().toLocaleDateString("tr-TR", { weekday: "long", year: "numeric", month: "long", day: "numeric" })}
            </span>
            </CollapseBar>
            <ParasutBadge />
            <button data-testid="ai-chat-open" onClick={() => setAiChat(true)} title="YAPAY ZEKAYA SOR" className="flex h-9 shrink-0 items-center gap-1 rounded-lg bg-fuchsia-600 px-2.5 text-xs font-bold text-white hover:bg-fuchsia-700"><Bot className="h-4 w-4" /> YAPAY ZEKAYA SOR</button>
            <div className="hidden h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gradient-to-br md:flex from-blue-500 to-indigo-600 text-sm font-bold text-white">
              {(user?.name || "?")[0]}
            </div>
          </div>
        </header>
        <div className="relative flex items-stretch">
          <div ref={barRefs.panel} data-testid="bar-panel" className={`relative flex min-w-0 flex-1 flex-nowrap items-center gap-1.5 overflow-hidden border-t border-slate-800 px-3 py-1.5 empty:hidden ${actionBars.includes(barOpen) || barOpen === "layout-kisayol" ? "mw-actions" : ""}`} />
          {more.length > 0 && (
            <div className="absolute right-2 top-1/2 -translate-y-1/2">
              <button data-testid="actions-more-button" onClick={() => setMoreOpen((o) => !o)} className="flex h-8 items-center gap-1 rounded-md border border-slate-600 bg-slate-800 px-3 text-xs font-bold text-slate-100 hover:bg-slate-700">
                DAHA FAZLA ({more.length}) <ChevronDown className="h-3.5 w-3.5" />
              </button>
              {moreOpen && (<>
                <div className="fixed inset-0 z-40" onClick={() => setMoreOpen(false)} />
                <div data-testid="actions-more-menu" className="absolute right-0 top-9 z-50 max-h-[70vh] min-w-[240px] overflow-y-auto rounded-lg border border-slate-700 bg-slate-900 p-1 shadow-xl">
                  {more.map((m, i) => (
                    <button key={m.key + i} data-testid={`actions-more-item-${i}`} onClick={() => { setMoreOpen(false); m.el.click(); }} className="block w-full whitespace-nowrap rounded px-3 py-2 text-left text-xs font-semibold text-slate-200 hover:bg-slate-800">{m.key}</button>
                  ))}
                </div>
              </>)}
            </div>
          )}
        </div>
        </div>
        {actionBars.length === 0 ? <CollapseBar id="layout-kisayol" label="İŞLEMLER"><TopActions items={topItems} /></CollapseBar>
          : actionBars.includes(barOpen) && barEls.panel && createPortal(<div data-testid="top-actions-wrap" className="order-first contents"><TopActions items={topItems} /></div>, barEls.panel)}
        <main className="min-w-0 flex-1 px-2 pb-24 pt-2 md:px-6 md:pb-6 md:pt-3" style={{ zoom: mobile ? 1 : zoom }}>{children}</main>
        </BarCtx.Provider>
      </div>
      <ChatWidget />
      <AiChatModal open={aiChat} onOpenChange={setAiChat} />
      <ReleaseBalloon version={version} />
    </div>
  );
}
